// Port of https://github.schibsted.io/finn/mfinn/blob/master/src/main/webapp/modules/controllers/adPaging.js
export interface PagingData {
  prev: string | null;
  next: string | null;
  search: string;
}

type SessionData = {
  search: string;
  urls: string[];
};

const storageKey = "searchItems";
const isBrowser = typeof document !== "undefined";

const loadFromSessionStorage = (): SessionData | null => {
  try {
    const stringData = isBrowser && window.sessionStorage.getItem(storageKey);
    let data = null;
    if (stringData) {
      data = JSON.parse(stringData);
    }
    return data?.urls && data.search ? data : null;
  } catch {
    // ignore session storage missing or incognito mode
    return null;
  }
};

const getThisIndex = (adUrls: string[], currentAdId: string) =>
  adUrls.findIndex((adUrl) => adUrl.includes(currentAdId));

const pagingLinks = (adUrls: string[], currentAdId: string) => {
  const thisIndex = getThisIndex(adUrls, currentAdId);
  return thisIndex === -1 ? [] : [adUrls[thisIndex - 1], adUrls[thisIndex + 1]];
};

export const handlePagingKeyDown = (nextPage: string) => (event: KeyboardEvent) => {
  if ((event.target as Element).closest("input, textarea")) {
    return;
  }

  // CMD/CTRL/ALT + right arrow
  if (event.code === "ArrowRight" && (event.metaKey || event.altKey) && !event.shiftKey && !event.ctrlKey) {
    // Normally, Alt/Cmd-RightArrow navigates forward. If there's
    // no forward history, navigate to the next item.
    // Wait 100 ms and assume navigation has happened.
    window.setTimeout(() => {
      location.href = nextPage;
    }, 100);
  }
};

export const getPagingData = (
  currentAdId: number,
  loader: () => SessionData | null = loadFromSessionStorage,
): PagingData | null => {
  const pagingData = loader();

  if (!pagingData) {
    return null;
  }

  const currentAdIdString = String(currentAdId);
  let adUrls = pagingData?.urls ?? [];
  adUrls = [...new Set(adUrls)]; // remove duplicates

  const searchIsFromCurrentAd = adUrls.find((adUrl) => adUrl.includes(currentAdIdString));
  if (searchIsFromCurrentAd) {
    const [prev, next] = pagingLinks(adUrls, currentAdIdString);

    return { prev, next, search: pagingData.search };
  }

  return null;
};
